export const TAB_VIEW_KANBAN = "kanban";
export const TAB_VIEW_LIST = "list";
export const TAB_VIEW_BEST_FIT = "best-fit";
export const TAB_VIEW_TIMELINE = "timeline";

export const INITIAL_NEW_OPPORTUNITY = {
  title: "",
  description: "",
  departmentAgency: "",
  customer: "",
  subTier: "",
  office: "",
  externalId: "",
  naicsCode: "",
  pscCode: "",
  setAside: "",
  type: "",
  popStreetAddress: "",
  popCity: "",
  popState: "",
  popCountry: "",
  popZip: "",
  city: "",
  state: "",
  countryCode: "",
  zipCode: "",
  status: "Active",
  primaryContactFullname: "",
  primaryContactEmail: "",
  primaryContactPhone: "",
  secondaryContactFullname: "",
  secondaryContactEmail: "",
  secondaryContactPhone: "",
  externalLink: "",
  dueDate: "",
  createdDate: "",
  frameworkAgreement: false,
};

export const OPPORTUNITY_REQUIRED_FIELDS = ["title"];
